import Ajax from './Ajax.js'

// Companies (partners) and their users, for administrators: the same API as the panel's Companies section
// (new-server/src/api/panel-company, new-server/src/api/panel-invitation).
const Companies = {
  list: (archived = false) => Ajax.get(`/panel/companies?archived=${archived ? 1 : 0}`),
  get: (id) => Ajax.get(`/panel/companies/${id}`),
  update: (id, body) => Ajax.put(`/panel/companies/${id}`, body),
  assignableForests: () => Ajax.get('/panel/forests'),
  releasableForests: (id) => Ajax.get(`/panel/companies/${id}/releasable`),
  assignTrees: (id, areaId, count) => Ajax.post(`/panel/companies/${id}/assign`, { areaId, count }),
  releaseTrees: (id, areaId, count) => Ajax.post(`/panel/companies/${id}/release`, { areaId, count }),
  archive: (id) => Ajax.post(`/panel/companies/${id}/archive`, {}),
  restore: (id, reassignTrees) => Ajax.post(`/panel/companies/${id}/restore`, { reassignTrees }),
  remove: (id, confirm) => Ajax.delete(`/panel/companies/${id}`, { confirm }),
  setUserBlocked: (id, userId, blocked) => Ajax.put(`/panel/companies/${id}/users/${userId}`, { blocked }),
  // invitations: an email with a one-time link (7 days) to choose a password; administrators also get the link
  invite: (body) => Ajax.post('/panel/invitations', body),
  resendInvitation: (userId) => Ajax.post(`/panel/invitations/${userId}/resend`, {}),
  revokeInvitation: (userId) => Ajax.post(`/panel/invitations/${userId}/revoke`, {}),
}

/** The message of an API error, or the fallback. */
export const apiError = (err, fallback) =>
  (err && err.response && err.response.data && ((err.response.data.error && err.response.data.error.message) || err.response.data.message)) || fallback;

export default Companies
